(function(){
'use strict';
if(window.BroekCampaignPerformance)return;

const nativeFetch=window.fetch.bind(window);
const NativeMutationObserver=window.MutationObserver;
let cartCache=null,cartCacheAt=0,cartInflight=null;
const CACHE_MS=1200;

/* Keep only the Shopping Agent's own shadow-DOM observer. The campaign's
   cart / quick-view / body / html observers are replaced by explicit events
   already emitted by the cart and offer flows, plus lightweight transition
   fallbacks below. */
if(NativeMutationObserver&&!window.__broekShoppingObserverTuned){
  window.MutationObserver=new Proxy(NativeMutationObserver,{
    construct(Target,args){
      const callback=args&&args[0];
      const observer=new Target(callback);
      if(callback?.name!=='syncShoppingAgentDock')return observer;
      const nativeObserve=observer.observe.bind(observer);
      observer.observe=function(target,options){
        const id=target?.id||'';
        const skip=target===document.body||target===document.documentElement||id==='minicart_wrapper'||id==='shopify-section-product-quickview';
        if(skip)return;
        return nativeObserve(target,options)
      };
      return observer
    }
  });
  window.__broekShoppingObserverTuned=true
}

let shoppingSyncTimer=0,shoppingSyncFrame=0;
function requestShoppingAgentSync(delay=0){
  if(delay>0){
    clearTimeout(shoppingSyncTimer);
    shoppingSyncTimer=setTimeout(()=>requestShoppingAgentSync(0),delay);
    return
  }
  if(shoppingSyncFrame)return;
  shoppingSyncFrame=requestAnimationFrame(()=>{
    shoppingSyncFrame=0;
    window.dispatchEvent(new Event('resize'))
  })
}

function urlOf(input){try{return new URL(typeof input==='string'?input:input?.url||'',location.origin)}catch{return null}}
function methodOf(input,init){return String(init?.method||input?.method||'GET').toUpperCase()}
function isCartRead(input,init){const u=urlOf(input);if(!u||u.origin!==location.origin||methodOf(input,init)!=='GET')return false;return /\/cart\.(?:js|json)$/.test(u.pathname)}
function isCartMutation(input,init){const u=urlOf(input);if(!u||u.origin!==location.origin||methodOf(input,init)==='GET')return false;return /\/cart\/(?:add|change|update|clear)\.js$/.test(u.pathname)}
function isFullCart(data){return !!(data&&Array.isArray(data.items)&&Object.prototype.hasOwnProperty.call(data,'item_count'))}
function responseFromCache(meta){return new Response(meta.text,{status:meta.status,statusText:meta.statusText,headers:meta.headers})}
function setCartMeta(text,response){cartCache={text,status:response.status,statusText:response.statusText,headers:Array.from(response.headers.entries())};cartCacheAt=Date.now()}
function invalidateCart(){cartCache=null;cartCacheAt=0}
async function readCart(input,init,force){
  if(!force&&cartCache&&Date.now()-cartCacheAt<CACHE_MS)return responseFromCache(cartCache);
  if(cartInflight)return cartInflight.then(responseFromCache);
  cartInflight=(async()=>{
    const response=await nativeFetch(input,init);
    const text=await response.clone().text();
    const meta={text,status:response.status,statusText:response.statusText,headers:Array.from(response.headers.entries())};
    if(response.ok){cartCache=meta;cartCacheAt=Date.now()}
    return meta
  })();
  try{return responseFromCache(await cartInflight)}finally{cartInflight=null}
}

window.fetch=function(input,init){
  if(isCartRead(input,init))return readCart(input,init,false);
  const mutation=isCartMutation(input,init);
  if(!mutation)return nativeFetch(input,init);
  invalidateCart();
  return nativeFetch(input,init).then(async response=>{
    try{
      const clone=response.clone(),data=await clone.json();
      if(response.ok&&isFullCart(data)){
        const text=JSON.stringify(data);
        setCartMeta(text,response)
      }else invalidateCart()
    }catch{invalidateCart()}
    return response
  })
};

window.BroekCartState={
  invalidate:invalidateCart,
  async get(force=false){
    const root=window.Shopify?.routes?.root||'/';
    const response=await readCart(root+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'},!!force);
    if(!response.ok)throw new Error('Could not load cart.');
    return response.json()
  },
  set(cart){
    if(!isFullCart(cart))return;
    const response=new Response(JSON.stringify(cart),{status:200,headers:{'content-type':'application/json'}});
    setCartMeta(JSON.stringify(cart),response)
  }
};

function stockIds(){
  try{return new Set(JSON.parse(document.querySelector('#broek-campaign-config [data-gift-variants-in-stock]')?.textContent||'[]').map(Number).filter(Boolean))}
  catch{return new Set()}
}
function parkOffer(offer){
  if(!offer||offer._broekGiftFragment)return;
  const grid=offer.querySelector('.broek-2j-offer__grid');
  if(!grid||!grid.children.length)return;
  const fragment=document.createDocumentFragment();
  while(grid.firstChild)fragment.appendChild(grid.firstChild);
  offer._broekGiftFragment=fragment;
  offer.dataset.broekGiftParked='1'
}
function pruneGiftStock(offer){
  const ids=stockIds();if(!ids.size)return;
  offer.querySelectorAll('[data-gift-card]').forEach(card=>{
    const control=card.querySelector('[data-gift-variant]');if(!control)return;
    let available=false;
    if(control.tagName==='SELECT'){
      control.querySelectorAll('option').forEach(option=>{const id=Number(option.value);if(id>0&&!ids.has(id))option.remove()});
      available=Array.from(control.options).some(option=>Number(option.value)>0)
    }else available=ids.has(Number(control.value));
    card.dataset.broekStock=available?'1':'0';
    if(!available)card.hidden=true
  })
}
const INITIAL_GIFT_BATCH=8,GIFT_BATCH=6;
function applyActiveGiftFilter(offer){
  const key=offer?.querySelector('[data-filter].is-active')?.dataset?.filter||'all';
  offer?.querySelectorAll('[data-gift-card]').forEach(card=>{
    const category=String(card.dataset.category||'').split(' ');
    card.hidden=card.dataset.broekStock==='0'||(key!=='all'&&!category.includes(key))
  })
}
function appendGiftBatch(offer,limit,filterKey=''){
  const fragment=offer?._broekGiftFragment,grid=offer?.querySelector('.broek-2j-offer__grid');if(!fragment||!grid)return false;
  const candidates=Array.from(fragment.children).filter(card=>!filterKey||String(card.dataset.category||'').split(' ').includes(filterKey));
  const batch=candidates.slice(0,limit);if(!batch.length)return fragment.children.length>0;
  const partial=document.createDocumentFragment();batch.forEach(card=>partial.appendChild(card));grid.appendChild(partial);
  pruneGiftStock(offer);applyActiveGiftFilter(offer);offer.updateButtons?.();
  if(!fragment.children.length){offer._broekGiftFragment=null;offer.dataset.broekGiftParked='0';return false}
  offer.dataset.broekGiftParked='partial';return true
}
function scheduleGiftBatches(offer){
  if(!offer?._broekGiftFragment||offer._broekGiftBatchScheduled)return;
  offer._broekGiftBatchScheduled=true;
  const run=()=>{
    offer._broekGiftBatchScheduled=false;
    if(offer.querySelector('[data-gift-drawer]')?.hidden)return;
    if(appendGiftBatch(offer,GIFT_BATCH))scheduleGiftBatches(offer)
  };
  if('requestIdleCallback' in window)requestIdleCallback(run,{timeout:180});else setTimeout(run,32)
}
function hydrateOffer(offer,filterKey=''){
  const fragment=offer?._broekGiftFragment;if(!fragment)return;
  if(filterKey&&filterKey!=='all')appendGiftBatch(offer,Number.MAX_SAFE_INTEGER,filterKey);
  else appendGiftBatch(offer,INITIAL_GIFT_BATCH);
  scheduleGiftBatches(offer)
}
function parkAll(){document.querySelectorAll('broek-2j-offer').forEach(parkOffer)}

document.addEventListener('click',event=>{
  const opener=event.target.closest?.('broek-2j-offer [data-open-gifts]');
  if(opener)hydrateOffer(opener.closest('broek-2j-offer'))
},true);
document.addEventListener('click',event=>{
  const add=event.target.closest?.('broek-2j-offer [data-add-gift]');
  if(!add)return;
  const offer=add.closest('broek-2j-offer');
  if(!offer||add.dataset.broekDelegatedAdd==='1')return;
  event.preventDefault();
  offer.addGift?.({currentTarget:add,preventDefault(){}})
});
document.addEventListener('change',event=>{
  const control=event.target.closest?.('broek-2j-offer [data-gift-variant]');
  if(control)control.closest('broek-2j-offer')?.updateButtons?.()
});
document.addEventListener('click',event=>{
  const filter=event.target.closest?.('broek-2j-offer [data-filter]');if(!filter)return;
  const offer=filter.closest('broek-2j-offer'),key=filter.dataset.filter||'all';
  hydrateOffer(offer,key);
  requestAnimationFrame(()=>applyActiveGiftFilter(offer))
},true);

/* Programmatic cart/gift changes don't always produce a user click. Trigger the
   existing resize-based Shopping Agent sync only at those known state changes. */
document.addEventListener('broek:offer-state',()=>requestShoppingAgentSync(0));
document.addEventListener('transitionend',event=>{
  if(event.target?.closest?.('#minicart_wrapper,#shopify-section-product-quickview,[data-gift-drawer],.product-quickview,.quickview,.quick-view,.product-modal'))requestShoppingAgentSync(0)
},true);

let countdownTimer=0;
function countdownParts(){
  const cfg=document.getElementById('broek-campaign-config');if(!cfg)return null;
  const start=new Date(cfg.dataset.start),end=new Date(cfg.dataset.end),now=Date.now();
  const waiting=Number.isFinite(start.getTime())&&now<start.getTime(),target=waiting?start:end,diff=target-now;
  if(!Number.isFinite(target.getTime())||diff<=0)return{label:'ENDED',aria:'Offer ended'};
  const mins=Math.max(1,Math.ceil(diff/60000)),hours=Math.floor(mins/60),days=Math.floor(hours/24),hrs=hours%24,mm=mins%60;
  const value=days>0?`${days}D ${String(hrs).padStart(2,'0')}H ${String(mm).padStart(2,'0')}M`:`${String(hours).padStart(2,'0')}H ${String(mm).padStart(2,'0')}M`;
  return{label:(waiting?'STARTS IN ':'ENDS IN ')+value,aria:(waiting?'Offer starts in ':'Offer ends in ')+value}
}
function offerAnnouncementMessages(){return Array.from(document.querySelectorAll('.announcement__bar-message')).filter(msg=>{const t=String(msg.textContent||'').replace(/\s+/g,' ').toUpperCase();return t.includes('2 JEANS')&&t.includes('TOP FREE')})}
function installCountdown(){
  offerAnnouncementMessages().forEach(msg=>{
    if(msg.querySelector('.broek-manual-countdown'))return;
    const el=document.createElement('span');el.className='broek-manual-countdown';el.setAttribute('aria-live','off');msg.append(' ',el)
  });
  const p=countdownParts();if(!p)return;
  document.querySelectorAll('.broek-manual-countdown').forEach(el=>{el.textContent=p.label;el.setAttribute('aria-label',p.aria)})
}
function installCountdownStyle(){
  if(document.getElementById('broek-manual-countdown-style'))return;
  const style=document.createElement('style');style.id='broek-manual-countdown-style';style.textContent='.broek-manual-countdown{display:inline-flex;align-items:center;margin-inline-start:8px;padding:3px 7px;border-radius:999px;background:#111;color:#c6ff00;font-size:10px;font-weight:850;letter-spacing:.055em;line-height:1.25;white-space:nowrap}@media(max-width:749px){.broek-manual-countdown{margin-inline-start:5px;padding:3px 6px;font-size:8px;letter-spacing:.035em}}';document.head.appendChild(style)
}
function markFreeShippingMarquee(){
  document.querySelectorAll('.sec__scrolling-text .marquee').forEach(marquee=>{
    const text=String(marquee.textContent||'').replace(/\s+/g,' ').toUpperCase();
    if(!text.includes('FREE SHIPPING ON ELIGIBLE ORDERS ABOVE EGP 1,500'))return;
    marquee.querySelectorAll('.animation-marquee').forEach((clone,index)=>{if(index>0)clone.setAttribute('aria-hidden','true');else clone.removeAttribute('aria-hidden')})
  })
}
function boot(){
  parkAll();
  markFreeShippingMarquee()
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',()=>{parkAll();markFreeShippingMarquee();requestShoppingAgentSync(0)});
window.addEventListener('pageshow',()=>{markFreeShippingMarquee();requestShoppingAgentSync(0)});
window.BroekCampaignPerformance={hydrateOffer,parkOffer,invalidateCart,syncShoppingAgent:requestShoppingAgentSync};
})();
